
import { ICustomInput } from './type'
import styles from './inputBox.styles.module.scss'
import { useFormContext, Controller } from 'react-hook-form'

const CustomInput = (props: ICustomInput) => {
    const { label, placeholder, rules, className, disabled, name, required, ...other } = props
    const { control } = useFormContext()
    return (
        <div className={`${styles.inputBox}`}>
            <label className="form-label">
                {label}
                {required && <span className={styles.requiredSing}>*</span>}
            </label>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({ field }) => (
                    <input
                        {...field}
                        className={`form-control ${className}`}
                        disabled={disabled}
                        placeholder={placeholder}
                        {...other}
                    />
                )}
            />
        </div>
    )
}

export default CustomInput
